import { useQuery } from "@tanstack/react-query";
import { getCustomerNotes } from "./customerNotesApi";

/** Notes of every category, newest first, read-only. */
export const useAllCustomerNotes = (customerId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["customer", customerId, "notes", { category: "ALL" }],
    queryFn: ({ signal }) => getCustomerNotes(customerId, undefined, signal),
  });
  return { notes: data ?? [], isLoading };
};
